import { render, staticRenderFns } from "./zhixi-report.vue?vue&type=template&id=2ce80373&"
import script from "./zhixi-report.vue?vue&type=script&lang=js&"
export * from "./zhixi-report.vue?vue&type=script&lang=js&"
import style0 from "./zhixi-report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "zhixi-report.vue"
export default component.exports